@if (error$(); as error) {
  <div class="preview-viewer-host__error" role="alert" data-testid="survey-preview-error">
    <span class="text__md fw__500 eiq-text-warn">{{ error.message }}</span>
    @if (error.canRestart) {
      <eiq-button
        [text]="error.restartText ?? 'Start Again'"
        [testId]="'survey-preview-start-again'"
        [disabled]="isBusy$()"
        [loading]="isBusy$()"
        (clicked)="onRestart()"
      />
    }
  </div>
} @else {
  @if (previewRun$(); as previewRun) {
    <div data-testid="survey-preview-viewer" [attr.aria-busy]="isBusy$()" [attr.inert]="isBusy$() ? '' : null">
      <empathy-viewer
        [previewMode]="true"
        [startSurvey]="previewRun.startSurvey"
        [settings]="previewRun.settings"
        [surveyTitle]="previewRun.surveyTitle"
        (completed)="onRestart()"
        (forceComplete)="onPreviewForceComplete()"
      ></empathy-viewer>
    </div>
  } @else {
    <eiq-loader />
  }
}
